import React, { useEffect, useState } from "react";
import { Rect } from "react-konva";

interface MondayTaskLoadingProps {
  width: number;
  height: number;
}

export const MondayTaskLoading = React.memo(({ width, height }: MondayTaskLoadingProps) => {
  const [opacity, setOpacity] = useState(1);
  const shimmerDuration = 1500; // milliseconds

  useEffect(() => {
    let animationFrame: number;
    let startTime: number;

    const animate = (currentTime: number) => {
      if (!startTime) startTime = currentTime;
      const elapsed = currentTime - startTime;
      const progress = (elapsed % shimmerDuration) / shimmerDuration;

      // Sinusoidal shimmer: smooth pulse from 0.8 to 1 and back
      const newOpacity = 0.8 + 0.2 * Math.sin(progress * Math.PI * 2);
      setOpacity(newOpacity);

      animationFrame = requestAnimationFrame(animate);
    };

    animationFrame = requestAnimationFrame(animate);

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [shimmerDuration]);

  const shimmerColor = "#E5E7EB";

  return (
    <Rect
      width={width}
      height={height}
      fill={shimmerColor}
      cornerRadius={10}
      stroke="#EBEDF3"
      strokeWidth={1}
      hitStrokeWidth={0}
      opacity={opacity}
    />
  );
});

MondayTaskLoading.displayName = "MondayTaskLoading";
